import { render, staticRenderFns } from "./ReviewImages.vue?vue&type=template&id=620a3f6d"
import script from "./ReviewImages.vue?vue&type=script&lang=js"
export * from "./ReviewImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports